<div class="sdp-section-container">
	<mat-card class="sdp-administrative-card-container">
		<mat-card-content class="sdp-administrative-card-content">
			<sdp-wizard-navigation-top selectedPage="{{ 'wizard/' + page }}"></sdp-wizard-navigation-top>
			<div class="sdp-wizard-router-outlet">
				<router-outlet></router-outlet>
			</div>
			<div class="sdp-administrative-wizard-pager-container">
				<sdp-wizard-navigation nextPage="{{ next }}" previousPage="{{ previous }}"></sdp-wizard-navigation>
			</div>
		</mat-card-content>
	</mat-card>
</div>